import React from 'react';
import styled from 'styled-components';
import { graphql, useStaticQuery } from 'gatsby';
import Img from 'gatsby-image';
import { theme } from '@style';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 12px 24px;
  margin-bottom: 24px;
  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.8);
`;
const Picture = styled(Img)`
  border-radius: 8px;
  width: 60px;
`;
const Details = styled.div`
  padding-left: 8px;
`;
const Name = styled.h3`
  color: ${theme.palette.white};
  font-weight: ${theme.fontBold700};
  padding: 4px 0;
  font-size: ${theme.fontSizes.lg};
`;

const Profession = styled.p`
  color: rgba(255, 255, 255, 0.6);
  padding: 4px 0;
  font-size: ${theme.fontSizes.xs};
`;

export const Profile = () => {
  const data = useStaticQuery(graphql`
    query {
      profileImage: file(relativePath: { eq: "profile.jpeg" }) {
        childImageSharp {
          fluid(maxWidth: 300) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `);
  return (
    <Wrapper>
      <Picture fluid={data.profileImage.childImageSharp.fluid} />
      {/* <div style={{ borderRadius: '8px', width: '60px' }}>
        <Image />
      </div> */}
      <Details>
        <Name>Marino Kolarić</Name>
        <Profession>Web Developer</Profession>
      </Details>
    </Wrapper>
  );
};
